const initialState = {
  error: "",
  payload: [],
  isLoading: false
}

export default initialState;